
import React, { useState, useEffect } from 'react'
import createPersistedState from 'use-persisted-state'
import { FiEye } from 'react-icons/fi'

import style from './Store.module.scss'

const key = 'com.box.developer'

const Store = ({
  children,
  placeholder,
  pattern,
  disabled = false,
  obscured = false,
  inline = false,
  id,
  field
}) => {
  const usePersistedState = createPersistedState(`${key}.${id}`)

  const [value, setValue] = usePersistedState('')
  const [actualValue, setActualValue] = useState('')
  const [valid, setValid] = useState(false)

  obscured = [true, 'true', ''].includes(obscured)
  disabled = [true, 'true', ''].includes(disabled)
  inline = [true, 'true', ''].includes(inline)

  const [visible, setVisible] = useState(!obscured)

  // validate on load
  useEffect(() => {   
    setValid(new RegExp(pattern).test(actualValue))
  }, [])

  useEffect(() => {   
    setActualValue((field && value) ? value[field] : value)
  }, [value])

  useEffect(() => {   
    setValid(new RegExp(pattern).test(actualValue))
  }, [actualValue])

  // // change the stored value
  const onChange = (event) => {
    if (disabled) { return }
    setValue(event.target.value)
  }

  return (
    <span 
      className={style.store} 
      onMouseEnter={() => setVisible(true)}
      onMouseLeave={() => setVisible(!obscured)}
      data-obscured={obscured}
      data-disabled={disabled}
      data-inline={inline}
    >
      <label>{ children }</label>
      <FiEye />
      <input 
        defaultValue={actualValue} 
        type={ visible ? 'text' : 'password'} 
        placeholder={placeholder} 
        pattern={pattern}
        data-valid={valid}
        data-has-value={actualValue && actualValue.length > 0}
        onChange={onChange}
        disabled={disabled} />
    </span>
  )
}

export default Store